/**
 * Accordion Component
 *
 * Generic single-panel expand/collapse component intended to be reused
 * by any card/list item that needs a "show more" style toggle (e.g. a
 * career listing showing only its title until expanded).
 *
 * Usage in HTML:
 *   <div data-x-data="accordion">
 *       <button data-x-on:click="toggle" data-x-bind:aria-expanded="open">...</button>
 *       <div data-x-show="open" data-x-transition>...</div>
 *   </div>
 *
 * An initial open state can be provided:
 *   <div data-x-data="accordion(true)">
 *
 * Exposed state:
 *   - open (boolean): Whether the panel is currently expanded
 */
export default function accordion(initialOpen = false) {
    return {
        open: !!initialOpen,

        toggle() {
            this.open = !this.open;
        },
    };
}
